module.exports = __webpack_public_path__ + "img/both.ee76dd2b.webp";